import cn from 'classnames'

import { useDropdown } from '@hooks/useDropdown'
import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'
import { MenuIcon } from '@components/icons/MenuIcon'
import {
  SelectChapterItemAcceptProps,
  SelectChapterItemProps,
} from './interface'

export function SelectChapter({
  children,
  isEbook,
  onScroll,
}: SelectChapterItemProps) {
  const { dropdownRef, isShowDropdown, toggleDropdown } = useDropdown()
  const { isNightTheme, isLightTheme, isDarkTheme, isSepiaTheme } = useTheme()

  return (
    <div ref={dropdownRef}>
      <button
        className={cn(
          'flex items-center whitespace-nowrap px-[20px] h-[40px] rounded-[20px] mobile:h-[30px] font-mitr font-medium',
          {
            'bg-gray-4 text-secondary': isLightTheme,
            'bg-dark-9 text-dark-10': isNightTheme,
            'bg-white text-secondary': isSepiaTheme,
            'bg-dark-3 text-gray-16': isDarkTheme,
          }
        )}
        type='button'
        onClick={toggleDropdown}
      >
        <MenuIcon width='24' height='24' className='mr-[10px]' />
        {isEbook ? 'สารบัญ' : 'เลือกตอน'}
      </button>

      <div
        className={cn(
          'fixed top-[120px] left-[108px] py-2.5 w-[341px] z-10 rounded-[10px] shadow border mobile:w-full mobile:!left-0 mobile:top-[110px]',
          {
            hidden: !isShowDropdown,
            'bg-white border-gray-4': isLightTheme,
            'bg-sepia border-sepia-1': isSepiaTheme,
            'bg-dark border-dark-3': isNightTheme,
            'bg-dark-5 border-dark-3': isDarkTheme,
          }
        )}
      >
        <div
          className='max-h-[380px] overflow-y-auto'
          onScroll={e => {
            if (onScroll) onScroll(e)
          }}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

SelectChapter.Item = ({
  children,
  isDarkTheme,
  isNightTheme,
  isLightTheme,
  isSepiaTheme,
}: SelectChapterItemAcceptProps) => {
  return (
    <div
      className={cn(
        'px-[25px] py-[8.5px] font-light truncate break-word text-left',
        {
          'text-sencondary hover:text-primary': isLightTheme || isSepiaTheme,
          'hover:bg-blue-2': isLightTheme,
          'hover:bg-sepia-3': isSepiaTheme,
          'text-white hover:bg-dark-6 hover:text-primary': isNightTheme,
          'text-gray-16 hover:bg-dark-7 hover:text-primary': isDarkTheme,
        }
      )}
    >
      {children}
    </div>
  )
}
